import makeApiRequest from './makeApiRequest'

const apiRequest = makeApiRequest()

export const getListProductionStage = (payload) => {
    return apiRequest({
        url: `production/stage?${payload}`,
        method: 'GET',
    })
}

export const getProductionStageDetail = (id) => {
    return apiRequest({
        url: `production/stage/${id}`,
        method: 'GET',
    })
}

export const createProductionStage = (payload) => {
    return apiRequest({
        url: `production/stage`,
        method: 'POST',
        data: payload,
    })
}

export const updateProductionStage = (id, payload) => {
    return apiRequest({
        url: `production/stage/${id}`,
        method: 'PUT',
        data: payload,
    })
}